import { render } from "./enquiry.html?vue&type=template&id=fd673e9e&scoped=true&lang=html&external"
import script from "./enquiry.vue?vue&type=script&lang=js"
export * from "./enquiry.vue?vue&type=script&lang=js"

import "./_enquiry.mobile.scss?vue&type=style&index=0&id=fd673e9e&lang=scss&scoped=true&external"
import "./_enquiry.desktop.scss?vue&type=style&index=1&id=fd673e9e&lang=scss&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd673e9e"]])

export default __exports__